import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Drawer,
  Modal,
  Pagination,
  Space,
  Spin,
  Table,
  Tooltip,
  message,
} from "antd";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { useNavigate } from "react-router-dom";
import AppointmentService from "../../Services/AppointmentService";
import ViewPrescription from "../MedicalRecords/MyPrescription/ViewPrescription";
import AuthService from "../../Services/AuthService";
import dayjs from "dayjs";
import Sharemedicalrecords from "../VideoConsultation/Sharemedicalrecords";
import axios from "axios";
import sha256 from "crypto-js/sha256";
import { Buffer } from "buffer";
import moment from "moment";
import PaymentService from "../../Services/PaymentService";
import { Base64 } from "js-base64";
import { LoadingOutlined } from "@ant-design/icons";
import PatientChat from "./PatientChat";
import { MdChatBubble } from "react-icons/md";
import UserService from "../../Services/UserService";
import close from "../../assets/images/close.png";
import TextArea from "antd/es/input/TextArea";
import ShareOrders from "./ShareOrders";
import MedicineDisabled from "../../assets/images/Svg/MedicineDisabled.svg";
import LabDisabled from "../../assets/images/Svg/LabDisabled.svg";
import shareMedRecord from "../../assets/images/shareMedRecord.jpg";
import { FaFilePrescription } from "react-icons/fa";
import ConsentComponent from "./ConsentComponent";
import { notifyDoctor } from "../../config/firebase";
import { setSelectedAppt } from "../../Redux/actions/appointmentActions";
import { useDispatch } from "react-redux";

const AppointmentTable = (props) => {
  const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [apptModalOpen, setApptModalOpen] = useState(false);
  const [prescriptionsList, setPrescriptionsList] = useState([]);
  const [selectedPrescription, setSelectedPrescription] = useState({});
  // const activePatient = JSON.parse(localStorage.getItem("patientData"));
  // const patientCode = activePatient?.patientId;
  const [appointmentData, setAppoinmentData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userCode, setUserCode] = useState("");
  const [isLoading, setIsLoading] = useState({
    fetchApp: false,
    cancelApp: false,
  });
  const [selectedChat, setSelectedChat] = useState(null);
  const [cancelAppointment, setCancelAppointment] = useState({});
  const [open, setOpen] = useState(false);
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const filterValues = props.filterValues;
  const [textValue, setTextValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const [refundable, setRefundable] = useState(false);
  const dispatch = useDispatch();
  const isDisabled = !textValue.trim();
  const selectedPatient = props.selectedPatient?.patientId;

  useEffect(() => {
    Appoinment(selectedPatient, currentPage, pageSize);
    fetchAllPrescriptions(selectedPatient);
  }, [props, currentPage, pageSize]);

  useEffect(() => {
    if (
      cancelAppointment &&
      cancelAppointment.status === 1 &&
      cancelAppointment.paymentType === "Digital"
    ) {
      setRefundable(true);
    }
  }, [cancelAppointment]);

  const handleApptCacel = (record) => {
    setApptModalOpen(true);
    setCancelAppointment(record);
  };

  const handleAppClose = () => {
    setApptModalOpen(false);
    setTextValue("");
    setRefundable(false);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handleApptCancelSubmit = () => {
    setIsLoading((prevState) => ({ ...prevState, cancelApp: true }));
    const payload = {
      appointmentId: cancelAppointment?.appointmentId,
      cancelReason: textValue,
      cancelledById: cancelAppointment?.patientId,
      cancelledByType: "Patient",
      refundYN: refundable ? "Y" : "N",
    };
    AppointmentService.AppointmentCancel(payload)
      .then((res) => {
        setIsLoading((prevState) => ({ ...prevState, cancelApp: false }));
        if (res.data == "Appointment cancelled successfully") {
          message.success("Appointment cancelled successfully");
          setApptModalOpen(false);
          setTextValue("");
          setRefundable(false);
          Appoinment(cancelAppointment?.patientId);
        }
      })
      .catch((e) => {
        console.error(e);
        setIsLoading((prevState) => ({ ...prevState, cancelApp: false }));
      });
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };
  const handleClick = async (details) => {
    if (details.serviceCode !== "APPT_VIDEO") {
      return;
    }
    const currentDate = new Date();
    const formattedDate = convertUTCDate(currentDate, "YYYY-MM-DD HH:mm:ss");

    try {
      let payload1 = {
        patientName: details?.patientName,
        personType: "Patient",
        appointmentId: details.appointmentId,
        modifiedBy: details.userId,
        modifiedDate: formattedDate,
        patientId: details.patientId,
        queueStatus: "Y",
        userId: details.userId,
        joiningDateTime: formattedDate,
      };
      await AppointmentService.callQueueUpdate(payload1);
      await notifyDoctor(
        details.patientId,
        details.appointmentId,
        details.patientName,
        details.userId,
      );
      dispatch(setSelectedAppt(details));
      localStorage.setItem("selectedAppt", JSON.stringify(details));
      navigate(APP_ROUTES.VIDEOCALL, {
        state: { selectedAppDetails: details },
      });
    } catch (error) {
      console.error("Error updating appointment or queue:", error);
    }
  };

  const patientName = `${props.selectedPatient?.salutation || ""} ${
    props.selectedPatient?.firstName || ""
  } ${props.selectedPatient?.lastName || ""}`.trim();

  const Appoinment = (patId, page, size) => {
    setIsLoading((prevState) => ({ ...prevState, fetchApp: true }));
    if (filterValues) {
      if (filterValues.fromDate) {
        filterValues.fromDate = dayjs(
          filterValues.fromDate,
          "MM/DD/YYYY",
        ).format("MM/DD/YYYY");
      }
      if (filterValues.toDate) {
        filterValues.toDate = dayjs(filterValues.toDate, "MM/DD/YYYY").format(
          "MM/DD/YYYY",
        );
      }
    }
    let payload = {
      patientId: patId,
      pageNo: page,
      pageSize: size,
    };
    // if (filterValues) {
    //   payload = {
    //     ...payload,
    //     fromDate: filterValues.fromDate,
    //     toDate: filterValues.toDate,
    //   };
    // }
    if (filterValues) {
      if (filterValues.fromDate) {
        payload.fromDate = filterValues.fromDate;
      }
      if (filterValues.toDate) {
        payload.toDate = filterValues.toDate;
      }
      if (filterValues.transactionId) {
        payload.transactionId = filterValues.transactionId;
      }
      if (filterValues.appointmentId) {
        payload.appointmentId = filterValues.appointmentId;
      }
      if (filterValues.userName) {
        payload.userName = filterValues.userName;
      }
    }
    AppointmentService.getPatientAppointment(payload)
      .then((result) => {
        setAppoinmentData(result.data);
        setIsLoading((prevState) => ({ ...prevState, fetchApp: false }));
        setHasMore(result.data?.length === size);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading((prevState) => ({ ...prevState, fetchApp: false }));
      });
  };

  const updatedAppointmentData = appointmentData?.map((user) => ({
    ...user,
    PatientName: patientName,
  }));

  const handlePayment = async (record) => {
    let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
    let transactionId = "MT" + date;
    let appointmentDetails =
      transactionId +
      "|" +
      record?.patientId +
      "|" +
      record?.userId +
      "|" +
      record?.appointmentId +
      "|" +
      record?.account_Id +
      "|" +
      record?.clinic_Id;
    let base64string = Base64.encode(appointmentDetails);
    let paymentPayload = {
      merchantTransactionId: transactionId,
      amount: parseFloat(record?.totalAmount) * 100,
      redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
      redirectMode: "POST",
      callbackUrl: `${process.env.REACT_APP_BASE_URL}/phonePeResponse1/paymentCallBackDetails`,
      mobileNumber: record?.patientMobile,
      paymentInstrument: {
        type: "PAY_PAGE",
      },
    };
    const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
    const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
    let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
    let base64EncodedPayload = bufferObj.toString("base64");
    let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
    let sha256_val = sha256(string);
    let xVerifyChecksum = sha256_val + "###" + 1;

    let phonepeTransaction = {
      account_Id: record?.account_Id,
      checksum: xVerifyChecksum,
      clinic_id: record?.clinic_Id,
      createdBy: record?.patientId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: record?.patientId,
      patientId: record?.patientId,
      enoCodePayload: base64EncodedPayload,
      providerreferenceId: "",
      serviceCode: "APPT",
      serviceName: "Appoinment Consultation",
      status: 1,
      transactionId: transactionId,
      serviceTransId: record?.appointmentId,
      userId: record?.userId,
      amount: record?.totalAmount,
      paymentType: record.paymentType,
    };
    try {
      const result =
        await PaymentService.PhonepeTransaction(phonepeTransaction);
      if (result.data === 1) {
        let billingTransaction = {
          account_Id: record?.account_Id,
          amount: record?.consultationFee,
          clinic_id: record?.clinic_Id,
          createdBy: record?.patientId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          discountAmount: 0,
          discountPercentage: 0,
          gst: 0,
          modifiedBy: record?.patientId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: record?.totalAmount,
          patientId: record?.patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "",
          serviceCost: record?.consultationFee,
          serviceName: "",
          serviceTransId: record?.appointmentId,
          status: 0,
          transactionId: transactionId,
          userId: record?.userId,
          billingTransactionServices: [],
        };

        let array1 = {
          account_Id: record?.account_Id,
          amount: record.consultationFee,
          clinic_id: record?.clinic_Id,
          createdBy: record?.userId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: record?.userId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: record?.totalAmount,
          patientId: record?.patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "APPT",
          serviceCost: record.consultationFee,
          serviceName: "Appointment Consultation",
          serviceTransId: record?.appointmentId,
          status: 0,
          toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          transactionId: transactionId,
          userId: record?.userId,
        };
        billingTransaction.billingTransactionServices.push(array1);

        const billingResult =
          await PaymentService.BillingTransaction(billingTransaction);
        if (billingResult.data === 1) {
          if (CURRENCYCODE !== "INR") {
            message.success("Payment Initiated Successfully");
            return;
          }

          let data1 = {
            merchantOrderId: transactionId,
            amount: parseFloat(record?.totalAmount) * 100,
            expireAfter: 1200,
            metaInfo: {
              udf1: "Appointment Consultation",
            },
            redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
          };

          PaymentService.V2initiatePayment(data1).then((response) => {
            window.location.replace(response.data.redirectUrl);
          });
        }
      }
    } catch (error) {
      console.error("Warning", error);
      return error.response;
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchAllPrescriptions = async (patId) => {
    let payload = {
      patientId: patId,
      detailsYN: "Y",
    };
    const response = await AuthService.getMyPrescriptionView(payload);
    setPrescriptionsList(response.data);
  };

  const handleShareClick = (record) => {
    if (record.shareMedWithDocs === "Y") {
      setUserCode(record.userId);
      setShowModal(true);
    } else {
      message.warning("Give Consent to share Medical Records");
      // navigate("/logconsent", { state: "/myappointments" });
      setUserCode(record.userId);
      setSelectedRecord(record);
      setConsentOpen(true);
    }
  };
  const [selectedRecord, setSelectedRecord] = useState(null);
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "PatientName",
      sorter: {
        compare: (a, b) => a.PatientName.localeCompare(b.PatientName),
      },
      width: 3000,
    },
    {
      title: "Patient Id",
      dataIndex: "patientId",
      sorter: {
        compare: (a, b) => a.patientId.localeCompare(b.patientId),
      },
    },
    {
      title: "Doctor Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Appointment ID",
      dataIndex: "appointmentId",
      sorter: {
        compare: (a, b) => a.appointmentId.localeCompare(b.appointmentId),
      },
    },
    {
      title: "Booked date",
      dataIndex: "createdDate",
      sorter: {
        compare: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
      },
      render: (text, record) => (
        // <span>{new Date(record.createdDate).toLocaleDateString("en-GB")}</span>
        <span>
          {dayjs.utc(record.createdDate).local().format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      title: "Appointment Date/Time",
      dataIndex: "startTime",
      render: (_, record) => {
        const [hours, minutes] = record.startTime.split(":");
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        const formattedTime = date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        const formattedDate = moment
          .utc(record.appointmentDate)
          .local()
          .format("DD/MM/YYYY");
        return (
          <span>
            {formattedDate}-{record.startTime}
          </span>
        );
      },
    },
    {
      title: "Consultation Reason",
      dataIndex: "appointmentReason",
    },
    {
      title: "Appointment Status",
      dataIndex: "status",
      render: (_, record) => (
        <Space size="middle" className="">
          {record.status === 9 && (
            <span className=" text-red-500 " disabled>
              Cancelled
            </span>
          )}
          {(record.status === 1 || record.status === 0) && (
            <span className=" text-[#189FAA] ">Pending</span>
          )}
          {record.status === 2 && (
            <span className=" text-green-500 ">Completed</span>
          )}
        </Space>
      ),
    },
    {
      title: "Payment",
      dataIndex: "payment",
      render: (_, record) => (
        <div>
          {record.transactionId && (
            <Button className="p-2 w-20 rounded-md text-white bg-[#189FAA] flex items-center justify-center">
              Paid
            </Button>
          )}
          {!record.transactionId && (
            <Button
              onClick={() => handlePayment(record)}
              className="p-2 w-20 rounded-md text-white bg-green-500 flex items-center justify-center"
            >
              Pay
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Payment Type",
      dataIndex: "paymentType",
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      render: (_, record) => (
        <div>{record.transactionId ? record.transactionId : "N/A"}</div>
      ),
    },
    {
      title: "Action",
      dataIndex: "joinConsultation",
      render: (_, record) => (
        <Space size="middle" className="">
          <div className="flex items-center !gap-2">
            <Space size="middle" className="">
              {(record.status === 2 ||
                record.status === 9 ||
                record.status === 0) && (
                <Button
                  className="p-2 w-20 rounded-md text-white bg-green-500 flex items-center justify-center"
                  disabled
                >
                  {record.serviceCode === "APPT_VIDEO" ? (
                    <>Join call</>
                  ) : (
                    <>Consult</>
                  )}
                </Button>
              )}
              {record.status === 1 && record.paymentConsultation == "AC" && (
                <div className="flex items-center gap-3">
                  <button
                    className="p-2 w-20 rounded-md text-white bg-green-500 flex items-center justify-center"
                    onClick={() => handleClick(record)}
                  >
                    {record.serviceCode === "APPT_VIDEO" ? (
                      <>Join call</>
                    ) : (
                      <>Consult</>
                    )}
                  </button>
                  <div className="">
                    <Tooltip placement="right" title={"Cancel"}>
                      <button
                        disabled={record.status !== 1}
                        onClick={() => handleApptCacel(record)}
                        className="border  border-gray-500 p-1 cursor-pointer rounded-lg disabled:cursor-not-allowed disabled:opacity-50"
                      >
                        <img className="w-4" src={close} alt="closeImage" />
                      </button>
                    </Tooltip>
                  </div>
                  {/* <MdChatBubble
                    className="text-xl text-blue-500"
                    role="button"
                    onClick={() => showDrawer(record)}
                  /> */}
                </div>
              )}
              {record.status === 1 &&
                record.paymentConsultation == "BC" &&
                record.transactionId && (
                  <div className="flex items-center gap-3">
                    <button
                      className="p-2 w-20 rounded-md text-white bg-green-500 flex items-center justify-center"
                      onClick={() => handleClick(record)}
                    >
                      {record.serviceCode === "APPT_VIDEO" ? (
                        <>Join call</>
                      ) : (
                        <>Consult</>
                      )}
                    </button>
                    <div className="">
                      <Tooltip title={"Cancel"}>
                        <button
                          disabled={record.status !== 1}
                          onClick={() => handleApptCacel(record)}
                          className="border  border-gray-500 p-1 cursor-pointer rounded-lg disabled:cursor-not-allowed disabled:opacity-50"
                        >
                          <img className="w-4" src={close} alt="closeImage" />
                        </button>
                      </Tooltip>
                    </div>
                    {/* <Tooltip title={"Chat"}>
                      <MdChatBubble
                        className="text-xl text-blue-500"
                        role="button"
                        onClick={() => showDrawer(record)}
                      />
                    </Tooltip> */}
                  </div>
                )}
              {record.status === 1 &&
                record.paymentConsultation == "BC" &&
                !record.transactionId && (
                  <Button
                    className="p-2 w-20 rounded-md text-white bg-green-500 flex items-center justify-center"
                    disabled
                  >
                    {record.serviceCode === "APPT_VIDEO" ? (
                      <>Join call</>
                    ) : (
                      <>Consult</>
                    )}
                  </Button>
                )}
            </Space>
          </div>
        </Space>
      ),
    },
    {
      title: "Orders",
      width: 100,
      dataIndex: "actions",
      render: (_, record) => {
        return (
          <Space size="middle" className="">
            <div className="flex items-center gap-2">
              <div size="middle" className="">
                {record.status === 2 ? (
                  <div className="flex gap-1 items-center cursor-pointer">
                    <ShareOrders record={record} />
                  </div>
                ) : (
                  <div className="flex gap-1 items-center cursor-pointer">
                    <img
                      src={MedicineDisabled}
                      alt="Preview"
                      className="w-8 h-8 cursor-not-allowed"
                      role="button"
                    />

                    <img
                      src={LabDisabled}
                      alt="Share"
                      className="w-8 h-8 cursor-not-allowed"
                      role="button"
                    />
                  </div>
                )}
              </div>
            </div>
          </Space>
        );
      },
    },
    {
      title: "Refund Status",
      dataIndex: "refundStatus",
      render: (_, record) => (
        <div>
          {record.status === 9 && record.refundStatus === 1 ? (
            <span className="text-yellow-500">Requested</span>
          ) : record.status === 9 && record.refundStatus === 2 ? (
            <span className="text-[#189FAA]">Request Approved</span>
          ) : record.status === 9 && record.refundStatus === 3 ? (
            <span className="text-dangerColor">Request Rejected</span>
          ) : record.status === 9 && record.refundStatus === 4 ? (
            <span className="text-successColor">Refunded</span>
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      title: "Refund Remarks",
      dataIndex: "refundRemarks",
    },
    {
      title: "Rx",
      dataIndex: "share",
      key: "share",
      render: (text, record) => (
        <div className="flex items-center gap-1">
          <Tooltip title="Share Medical Records">
            <button
              className="disabled:cursor-not-allowed disabled:opacity-50"
              onClick={() => handleShareClick(record)}
              disabled={record.status === 9}
            >
              {/* Share Medical Records */}
              <img
                src={shareMedRecord}
                alt="Share Medical Records"
                className="w-6 h-6 rounded"
              />
            </button>
          </Tooltip>
          <div className="">
            {/* {record.status === 2 && record.transactionId && ( */}
            <Tooltip title="View Prescription">
              <button
                className="flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-50"
                onClick={() => handleViewClick(record)}
                disabled={!(record.status === 2 && record.transactionId)}
              >
                {/* View prescription */}
                <FaFilePrescription className="text-secondaryColor w-6 h-6" />
              </button>
            </Tooltip>
            {/* )} */}
          </div>
        </div>
      ),
    },
    // {
    //   title: "Prescription",
    //   dataIndex: "prescription",
    //   render: (_, record) => (
    //     <div className="">
    //       {record.status === 2 && record.transactionId && (
    //         <Button
    //           className="p-2 rounded-md bg-secondaryColor text-white flex items-center justify-center"
    //           onClick={() => handleViewClick(record)}
    //         >
    //           View prescription
    //         </Button>
    //       )}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Cancel",
    //   dataIndex: "cancel",
    //   render: (_, record) => (
    //     <div className="">
    //       <Tooltip placement="right" title={"Cancel"}>
    //         <button
    //           disabled={record.status !== 1}
    //           onClick={() => handleApptCacel(record)}
    //           className="border  border-gray-500 p-1 cursor-pointer rounded-lg disabled:cursor-not-allowed disabled:opacity-50"
    //         >
    //           <img className="w-4" src={close} alt="closeImage" />
    //         </button>
    //       </Tooltip>
    //     </div>
    //   ),
    // },
  ];

  const handleViewClick = (record) => {
    let payload = {
      patientId: props.selectedPatient.patientId,
      detailsYN: "Y",
      consultationId: record?.consultationId,
    };
    AuthService.getMyPrescriptionView(payload).then((result) => {
      setSelectedPrescription(result.data[0]);
      setIsModalOpen(true);
    });
  };

  const showDrawer = async (record) => {
    setOpen(true);
    try {
      const response = await getDoctorDetails(record.userId);
      const dataObj = { ...record, imageName: response.imageName };
      setSelectedChat(dataObj);
    } catch (e) {
      console.error(e);
    }
  };

  const getDoctorDetails = async (id) => {
    const userPayload = { userId: id, displayInWebsite: "Y", status: 1 };
    try {
      const response = await UserService.getDoctors(userPayload);
      return response?.data?.filter((item) => item.userType === "P")[0];
    } catch (e) {
      console.error(e);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  const [consentOpen, setConsentOpen] = useState(false);

  const showConsent = () => {
    setConsentOpen(true);
  };

  const handleConsentOk = () => {
    setConsentOpen(false);
  };

  const handleConsentCancel = () => {
    setConsentOpen(false);
  };

  return (
    <div>
      <div className="flex flex-col h-screen justify-between">
        {/* <div className="w-full" id="unquie-scroll"> */}
        <Table
          columns={columns}
          dataSource={updatedAppointmentData}
          loading={{
            spinning: isLoading.fetchApp,
            indicator: <Spin indicator={loadingIcon} size="large" />,
          }}
          pagination={false}
          // scroll={{ x: "max-content", y: false }}
          className="w-full overflow-x-auto"
        />
        <div className="flex justify-center items-center my-10">
          <Pagination
            current={currentPage}
            total={
              hasMore ? currentPage * pageSize + 1 : currentPage * pageSize
            }
            pageSize={pageSize}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      </div>

      {consentOpen && (
        <Modal
          title=""
          open={consentOpen}
          onOk={handleConsentOk}
          onCancel={handleConsentCancel}
          style={{ top: 20 }}
          width={1000}
          footer={[]}
        >
          <ConsentComponent
            selectedRecord={selectedRecord}
            setConsentOpen={setConsentOpen}
            setShowModal={setShowModal}
            Appoinment={Appoinment}
          />
        </Modal>
      )}

      <Modal
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{
          top: 40,
        }}
        width={"70%"}
        footer={null}
        destroyOnClose
      >
        <ViewPrescription
          prescription={selectedPrescription}
          selectedPatient={props.selectedPatient}
        />
      </Modal>

      {showModal && (
        <Sharemedicalrecords
          selectedPatient={props.selectedPatient}
          userId={userCode}
          onClose={handleCloseModal}
        />
      )}

      <Drawer
        destroyOnClose
        // props={record}
        title={
          <div className="w-full flex items-center gap-3 m-0 p-3 bg-[#20638e] text-white">
            <div>
              <img
                src={process.env.REACT_APP_IMAGE_URL + selectedChat?.imageName}
                className="w-10 h-10 rounded-full"
                alt="doctor"
              />
            </div>
            <div className="flex flex-col">
              <div>{selectedChat?.userName}</div>
              <div>({selectedChat?.userId})</div>
            </div>
          </div>
        }
        onClose={onClose}
        open={open}
        closable={false}
      >
        <PatientChat selectedChat={selectedChat} />
      </Drawer>

      {/* Appointment cancel */}
      <Modal
        title="Cancel Appointment"
        open={apptModalOpen}
        // onOk={handleOk}
        onCancel={handleAppClose}
        footer={
          <div className="mt-6">
            <button
              className="mx-1 p-1 w-28 font-semibold text-brand-primaryColor border border-brand-primaryColor rounded-md"
              onClick={handleAppClose}
            >
              No, Close
            </button>
            <button
              className={`mx-1 p-1 w-28 font-semibold rounded-md ${
                isDisabled
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "custom_filter bg-brand-primaryColor text-white"
              }`}
              onClick={handleApptCancelSubmit}
              disabled={isDisabled}
            >
              Yes, Cancel
            </button>
          </div>
        }
        destroyOnClose
      >
        Do you want to cancel this appointment?
        <TextArea
          rows={4}
          value={textValue}
          onChange={(e) => setTextValue(e.target.value)}
        />
        <label className="mr-2">Refund Applicable :</label>
        <Checkbox
          onChange={handleRefundable}
          checked={refundable}
          disabled={
            cancelAppointment.status === 0 ||
            cancelAppointment.status === 9 ||
            (cancelAppointment.paymentType === "FullDiscount" &&
              cancelAppointment.status === 1) ||
            cancelAppointment.paymentType === "Cash"
          }
        />
      </Modal>
    </div>
  );
};

export default AppointmentTable;
